import { POST_COUPONS, POST_COUPONS_SUCCESS, POST_COUPONS_ERROR, GET_EMPTY_POST_COUPON } from './../../actionType.js';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const PostCoupons = (state = initialState, action) => {
  switch (action.type) {
    case POST_COUPONS:
      state = {
        ...state,
        data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case POST_COUPONS_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case POST_COUPONS_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case GET_EMPTY_POST_COUPON:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default PostCoupons;
